import React, { useEffect, useState } from 'react'
import { API_URL, BASE_URL, PASSWORD, USERNAME } from '../../constants';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import { getApiAction, getSiteId } from '../../Utils/helper';
import { useDispatch } from 'react-redux';

const Sidebar = () => {
    const [catResponseData, setCatResponseData] = useState(null);
    const { id: category_id } = useParams();
    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
          const fetchData = async () => {
            try {
            let catResponse = await getApiAction("products/categories", {}, 0, dispatch);

              setCatResponseData(catResponse);
            } catch (error) {
              console.error("Error fetching data:", error);
            }
          };
    
          fetchData();
        };
      }, []);

      
  return (
    <div>
         <div className="sideBar">
              <ul>
                  {catResponseData?.common_categories?.map((item) => (
                  <li className={item.name == category_id ? 'active' : ''}>
                    <Link to={`/${getSiteId()}/product/${item.name}`}>
                      {/* <img src={item.default_image} alt="" /> */}
                      <img
                        src={item.default_image}
                        alt=""
                      />

                      <h4>{item.name}</h4>
                    </Link>
                  </li>
                  ))}
              </ul>
            </div>
    </div>
  )
}

export default Sidebar